import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_SOURCEPROXY_ADD,
    RESPOND_SOURCEPROXY_CONFIG,
    RESPOND_SOURCEPROXY_REMOVE,
    RESPOND_SOURCEPROXY_UPDATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/config/sourceProxyMsgDefinitions";
import { SourceProxyID, SourceProxySettings } from "userful-chronos-app-common-js/dist/models/config/sourceProxy";
import configStore from "../networkConfigStore";
import { sourceProxySliceActions } from "../sourceProxySlice";

registerMsgHandler(RESPOND_SOURCEPROXY_CONFIG, (payload) => {
    console.debug("receive RESPOND_SOURCEPROXY_CONFIG");
    const data = JSON.parse(payload) as SourceProxySettings[];
    configStore.dispatch(sourceProxySliceActions.setProxyData(data));
});

registerMsgHandler(RESPOND_SOURCEPROXY_ADD, (payload) => {
    console.debug("receive RESPOND_SOURCEPROXY_ADD");
    const data = JSON.parse(payload) as SourceProxySettings;
    configStore.dispatch(sourceProxySliceActions.addOrUpdateProxy(data));
    configStore.dispatch(sourceProxySliceActions.setSaveBool(false));
    configStore.dispatch(sourceProxySliceActions.setOverlay(false));
});

registerMsgHandler(RESPOND_SOURCEPROXY_UPDATE, (payload) => {
    console.debug("receive RESPOND_SOURCEPROXY_UPDATE");
    const data = JSON.parse(payload) as SourceProxySettings;
    configStore.dispatch(sourceProxySliceActions.addOrUpdateProxy(data));
    configStore.dispatch(sourceProxySliceActions.setSaveBool(false));
    configStore.dispatch(sourceProxySliceActions.setOverlay(false));
});

registerMsgHandler(RESPOND_SOURCEPROXY_REMOVE, (payload) => {
    console.debug("receive RESPOND_SOURCEPROXY_REMOVE");
    const data = JSON.parse(payload) as SourceProxyID;
    configStore.dispatch(sourceProxySliceActions.removeProxy(data));
    configStore.dispatch(sourceProxySliceActions.setSaveBool(false));
});
